import React from 'react';

import Text from '../../../../ui/Text';
import { AccentButton } from '../../../../ui/Button';

import * as Styles from './ModalAuthorizationStyles';

interface Props {
  handleCancel: () => void;
  handleAuthorized: () => void;
}

const ModalAuthorization: React.FC<Props> = ({ handleCancel, handleAuthorized }: Props) => {
  return (
    <Styles.Container>
      <Text scale="heading5" align="center" color="black">
        Autorizar cadastro com SNGPC
      </Text>
      <Text scale="heading6" align="center" color="black80" marginTop={16}>
        A Memed estará apta a acessar:
      </Text>
      <Text scale="caption1" color="black" marginTop={32}>
        Dados cadastrais da sua farmácia.
      </Text>
      <Text scale="caption2" color="black80" marginTop={8}>
        Ex: Nome Fantasia, Razão Social, CNPJ, CNAE, Endereço.
      </Text>

      <Text scale="caption1" color="black" marginTop={32}>
        Dados dos responsáveis.
      </Text>
      <Text scale="caption2" color="black80" marginTop={8}>
        Ex: Nome, E-mail, CRF.
      </Text>

      <Text align="center" scale="caption2" color="black80" marginTop={32}>
        Este site é responsável pelo uso de suas informações de acordo com sua
        <a
          target="_black"
          href="https://suporte-farmacia.memed.com.br/hc/pt-br/categories/12862095041819-Termos-Pol%C3%ADticas"
        >
          {' '}
          Política de Segurança{' '}
        </a>{' '}
        e
        <a target="_black" href="https://www.memed.com.br/termos-de-uso">
          {' '}
          Termos de Uso
        </a>
        .
      </Text>

      <Styles.ActionsContainer>
        <AccentButton onClick={handleAuthorized} bgColor="primary" type="submit" width="280px" autoFocus>
          Autorizar
        </AccentButton>
        <Styles.ButtonCancel onClick={handleCancel}>Cancelar</Styles.ButtonCancel>
      </Styles.ActionsContainer>
    </Styles.Container>
  );
};

export default ModalAuthorization;
